import React from 'react'
import GatsbyImage from 'gatsby-image'
import { FaPodcast } from 'react-icons/fa'

import './podcast-card.scss'
import Anchor from '../../../shared/components/anchor/anchor'

type PodcastCardProps = {
  slug: string
  thumbnail?: string | null
  title: string
  date: string
  excerpt?: string | null
}

const PodcastCard: React.FC<PodcastCardProps> = ({
  slug,
  thumbnail,
  title,
  date,
  excerpt
}) => {
  return (
    <Anchor to={slug} className="podcast-card">
      <GatsbyImage
        className="podcast-card-image bg-whitish"
        fluid={{
          aspectRatio: 16 / 9,
          src: `${thumbnail}?nf_resize=fit&w=512`,
          srcSet: `
            ${thumbnail}?nf_resize=fit&w=512 512w,
            ${thumbnail}?nf_resize=fit&w=320 320w,
            ${thumbnail}?nf_resize=fit&w=160 160w
          `,
          sizes: `
            (min-width: 36em) 33.3vw,
            100vw
          `
        }}
      />
      <div className="podcast-card-overlay">
        <FaPodcast className="podcast-card-overlay-icon" />
        <span className="podcast-card-overlay-label">Listen to Podcast</span>
      </div>
      <h5 className="podcast-card-title">
        {title} <span className="subtitle font-M"> — {date}</span>
      </h5>
      <div className="podcast-card-excerpt fg-blackish">{excerpt}</div>
    </Anchor>
  )
}

export default PodcastCard
